import React from 'react';
import { Card, Badge } from 'react-bootstrap';
//import './AllergensWarningStyles.css';

const AllergensWarning = ({ allergens }) => {
    if (!allergens?.length) return null;

    return (
        <Card className="clean-card shadow-sm mb-4">
            <div className="card-header">
                <h4 className="mb-0">
                    <span className="allergen-icon">⚠️</span> Allergen Warning
                </h4>
            </div>
            <Card.Body>
                <p className="text-muted mb-3">This product may contain the following allergens:</p>
                <div className="allergen-badges">
                    {allergens.map((allergen, idx) => (
                        <Badge key={idx} className="badge danger allergen-badge">
                            {allergen}
                        </Badge>
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};

export default AllergensWarning;
